import { render, staticRenderFns } from "./sDataInsured.vue?vue&type=template&id=1ccbfc96"
import script from "./sDataInsured.vue?vue&type=script&lang=js"
export * from "./sDataInsured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports